/* ====================================================================
   SMOON · MEGA MENU — comportement (DOM unique desktop + mobile)
   Desktop ≥ 990 px : ouverture au survol (hover intent), rail à onglets,
   clavier (ArrowDown ouvre, Escape ferme, focusout referme).
   Mobile < 990 px : drawer plein écran, accordéons N1/N2, focus trap.
   Liens obfusqués : <span data-smn-l="base64"> décodés au clic/clavier.
   ==================================================================== */
(function () {
  'use strict';
  if (customElements.get('mega-menu')) return;

  var BP = window.matchMedia('(min-width: 990px)');
  var OPEN_DELAY = 60;
  var CLOSE_DELAY = 130;

  class SmoonMegaMenu extends HTMLElement {
    connectedCallback() {
      this.nav = this.querySelector('.smn-nav');
      this.burger = this.querySelector('.smn-burger');
      this.overlay = this.querySelector('[data-smn-overlay]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('[data-smn-item]'));
      if (!this.nav) return;

      this._timers = new WeakMap();
      this._lastPointer = 'mouse';
      this._bind();
    }

    disconnectedCallback() {
      document.documentElement.classList.remove('smn-lock');
    }

    /* mode barre : assez large ET le menu tient ; sinon burger + drawer */
    _bar() {
      return BP.matches && !this.classList.contains('smn--collapsed');
    }

    /* ---------------- bindings ---------------- */
    _bind() {
      var self = this;

      if (this.burger) {
        this.burger.addEventListener('click', function () {
          self.classList.contains('smn--open') ? self.closeDrawer() : self.openDrawer();
        });
      }
      if (this.overlay) {
        this.overlay.addEventListener('click', function () {
          self.closeDrawer();
          self.closeAllPanels();
        });
      }
      var closeBtn = this.querySelector('.smn-close');
      if (closeBtn) closeBtn.addEventListener('click', function () { self.closeDrawer(); });

      this.addEventListener('pointerdown', function (e) { self._lastPointer = e.pointerType || 'mouse'; }, true);

      this.items.forEach(function (item) { self._bindItem(item); });

      /* liens obfusqués (SEO) : décodage au clic / Entrée / Espace */
      this.addEventListener('click', function (e) {
        var obf = e.target.closest('[data-smn-l]');
        if (obf) window.location.assign(atob(obf.getAttribute('data-smn-l')));
      });
      this.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var obf = e.target.closest('[data-smn-l]');
        if (obf) { e.preventDefault(); window.location.assign(atob(obf.getAttribute('data-smn-l'))); }
      });

      document.addEventListener('keydown', this._onDocKeydown = function (e) {
        if (e.key !== 'Escape') return;
        if (self.classList.contains('smn--open')) { self.closeDrawer(); return; }
        var open = self.querySelector('.smn-item.is-open');
        if (open) { self.closePanel(open); open.querySelector('.smn-l1-link').focus(); }
      });

      /* focus trap dans le drawer mobile */
      this.nav.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || self._bar() || !self.classList.contains('smn--open')) return;
        var focusables = self.nav.querySelectorAll('a[href], button, [tabindex="0"], select, input');
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });

      var onBPChange = function () { self._resetAll(); self._fitBar(); };
      BP.addEventListener ? BP.addEventListener('change', onBPChange) : BP.addListener(onBPChange);

      /* burger adaptatif : bascule en drawer dès que la barre ne tient plus */
      this._l1 = this.nav.querySelector('.smn-l1');
      this._header = this.closest('.header') || this.parentElement;
      if ('ResizeObserver' in window && this._l1) {
        this._ro = new ResizeObserver(function () { self._fitBar(); });
        this._ro.observe(this._header);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self._fitBar(true); });
      this._fitBar();

      /* éditeur de thème : ouvrir le panneau contenant le bloc sélectionné */
      document.addEventListener('shopify:block:select', function (e) {
        var item = e.target && e.target.closest ? e.target.closest('[data-smn-item]') : null;
        if (!item) return;
        if (self._bar()) self.openPanel(item);
        else { self.openDrawer(); self._expandItem(item, true); }
      });
    }

    _bindItem(item) {
      var self = this;
      var link = item.querySelector('.smn-l1-link');
      var panel = item.querySelector('.smn-panel');
      var tabs = Array.prototype.slice.call(item.querySelectorAll('[data-smn-tab]'));

      if (panel) {
        /* survol desktop avec intention */
        item.addEventListener('pointerenter', function (e) {
          if (!self._bar() || e.pointerType === 'touch') return;
          self._clearTimer(item);
          self._setTimer(item, function () { self.openPanel(item); }, OPEN_DELAY);
        });
        item.addEventListener('pointerleave', function (e) {
          if (!self._bar() || e.pointerType === 'touch') return;
          self._clearTimer(item);
          self._setTimer(item, function () { self.closePanel(item); }, CLOSE_DELAY);
        });

        /* clavier : ArrowDown ouvre et entre dans le panneau */
        link.addEventListener('keydown', function (e) {
          if (!self._bar()) return;
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            self.openPanel(item);
            var target = item.querySelector('.smn-tab') || item.querySelector('.smn-link, .smn-seeall');
            if (target) target.focus();
          }
        });

        /* focus sorti de l'item (desktop) : refermer */
        item.addEventListener('focusout', function (e) {
          if (!self._bar()) return;
          if (!item.contains(e.relatedTarget)) self.closePanel(item);
        });

        link.addEventListener('click', function (e) {
          if (!self._bar()) {
            /* drawer (mobile ou replié) : la ligne N1 déplie l'accordéon */
            e.preventDefault();
            self._expandItem(item, !item.classList.contains('is-exp'));
            return;
          }
          /* desktop tactile (iPad) : 1er tap ouvre, 2e tap navigue */
          if (self._lastPointer === 'touch' && !item.classList.contains('is-open')) {
            e.preventDefault();
            self.openPanel(item);
          }
        });
      }

      tabs.forEach(function (tab) {
        var activate = function () { self._activateTab(item, tab); };
        tab.addEventListener('pointerenter', function (e) {
          if (self._bar() && e.pointerType !== 'touch') activate();
        });
        tab.addEventListener('focus', function () { if (self._bar()) activate(); });
        tab.addEventListener('click', function () {
          if (self._bar()) { activate(); return; }
          self._toggleGroup(item, tab);
        });
      });
    }

    /* ---------------- desktop : panneaux + onglets ---------------- */
    openPanel(item) {
      var self = this;
      this.items.forEach(function (other) { if (other !== item) self.closePanel(other); });
      if (item.classList.contains('is-open')) return;
      item.classList.add('is-open');
      this.classList.add('smn--panel-open');
      var link = item.querySelector('.smn-l1-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    closePanel(item) {
      this._clearTimer(item);
      if (!item.classList.contains('is-open')) return;
      item.classList.remove('is-open');
      var link = item.querySelector('.smn-l1-link');
      if (link) link.setAttribute('aria-expanded', 'false');
      if (!this.querySelector('.smn-item.is-open')) this.classList.remove('smn--panel-open');
    }

    closeAllPanels() {
      var self = this;
      this.items.forEach(function (item) { self.closePanel(item); });
    }

    _activateTab(item, tab) {
      if (tab.classList.contains('is-on')) return;
      item.querySelectorAll('[data-smn-tab]').forEach(function (t) {
        t.classList.remove('is-on');
        t.setAttribute('aria-expanded', 'false');
      });
      item.querySelectorAll('[data-smn-group]').forEach(function (g) { g.classList.remove('is-on'); });
      tab.classList.add('is-on');
      tab.setAttribute('aria-expanded', 'true');
      var group = item.querySelector('#' + tab.getAttribute('aria-controls'));
      if (group) group.classList.add('is-on');
    }

    /* ---------------- mobile : drawer + accordéons ---------------- */
    openDrawer() {
      this.classList.add('smn--open');
      document.documentElement.classList.add('smn-lock');
      if (this.burger) this.burger.setAttribute('aria-expanded', 'true');
      /* focus sur le conteneur (pas le bouton X) : pas d'anneau visible a l'ouverture */
      this.nav.focus({ preventScroll: true });
    }

    closeDrawer() {
      if (!this.classList.contains('smn--open')) return;
      this.classList.remove('smn--open');
      document.documentElement.classList.remove('smn-lock');
      if (this.burger) { this.burger.setAttribute('aria-expanded', 'false'); this.burger.focus(); }
    }

    _expandItem(item, expand) {
      var self = this;
      this.items.forEach(function (other) {
        if (other !== item && other.classList.contains('is-exp')) {
          other.classList.remove('is-exp');
          var l = other.querySelector('.smn-l1-link');
          if (l) l.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-exp', expand);
      var link = item.querySelector('.smn-l1-link');
      if (link) link.setAttribute('aria-expanded', expand ? 'true' : 'false');
    }

    _toggleGroup(item, tab) {
      var bar = this._bar();
      var group = item.querySelector('#' + tab.getAttribute('aria-controls'));
      var willOpen = !(group && group.classList.contains('is-open'));
      item.querySelectorAll('[data-smn-tab]').forEach(function (t) {
        t.classList.remove('is-open');
        if (!bar) t.setAttribute('aria-expanded', 'false');
      });
      item.querySelectorAll('[data-smn-group]').forEach(function (g) { g.classList.remove('is-open'); });
      if (willOpen && group) {
        tab.classList.add('is-open');
        tab.setAttribute('aria-expanded', 'true');
        group.classList.add('is-open');
      }
    }

    /* ---------------- divers ---------------- */
    _resetAll() {
      this.closeDrawer();
      this.closeAllPanels();
      this.items.forEach(function (item) {
        item.classList.remove('is-exp');
        item.querySelectorAll('[data-smn-tab].is-open, [data-smn-group].is-open').forEach(function (el) {
          el.classList.remove('is-open');
        });
      });
    }

    _fitBar(remeasure) {
      if (!this._l1 || !this._header) return;
      if (!BP.matches) {
        this.classList.remove('smn--collapsed');
        this._header.classList.remove('header--mm-collapsed');
        return;
      }

      var collapsed = this.classList.contains('smn--collapsed');

      /* re-mesure forcée (chargement des polices) : on réaffiche la barre le
         temps d'une lecture, dans la même frame, donc sans repaint visible.
         Les DEUX classes doivent être retirées, sinon la grille du header
         replié fausse la mesure. */
      if (collapsed && remeasure) {
        this.classList.remove('smn--collapsed');
        this._header.classList.remove('header--mm-collapsed');
        this._needW = this._l1.scrollWidth;
        this.classList.add('smn--collapsed');
        this._header.classList.add('header--mm-collapsed');
      } else if (!collapsed) {
        this._needW = this._l1.scrollWidth;
      }
      if (!this._needW) return;

      var cs = window.getComputedStyle(this._header);
      var logoEl = this._header.querySelector('.header__heading-link img')
        || this._header.querySelector('.header__heading-link');
      var logoW = logoEl ? logoEl.getBoundingClientRect().width : 0;
      var icons = this._header.querySelector('.header__icons');
      var avail = this._header.clientWidth
        - (parseFloat(cs.paddingLeft) || 0)
        - (parseFloat(cs.paddingRight) || 0)
        - logoW
        - (icons ? icons.getBoundingClientRect().width : 0)
        - 40;

      if (!collapsed && this._needW > avail) {
        this.classList.add('smn--collapsed');
        this._header.classList.add('header--mm-collapsed');
        this.closeAllPanels();
      } else if (collapsed && this._needW <= avail - 16) {
        this.classList.remove('smn--collapsed');
        this._header.classList.remove('header--mm-collapsed');
        this.closeDrawer();
      } else if (collapsed) {
        this._header.classList.add('header--mm-collapsed');
      }
    }

    _setTimer(item, fn, delay) { this._timers.set(item, window.setTimeout(fn, delay)); }
    _clearTimer(item) {
      var t = this._timers.get(item);
      if (t) { window.clearTimeout(t); this._timers.delete(item); }
    }
  }

  customElements.define('mega-menu', SmoonMegaMenu);

  /* Sélecteur de langue de l'en-tête (drapeau, visible aussi sur mobile).
     details-disclosure ne le referme qu'à la perte du focus, et au toucher
     tous les navigateurs ne donnent pas le focus au <summary> : on le referme
     quand on touche ailleurs, et aria-expanded suit l'ouverture. */
  var LANG_SEL = '.header__icons details.locale-switcher';

  document.addEventListener('pointerdown', function (e) {
    Array.prototype.forEach.call(document.querySelectorAll(LANG_SEL + '[open]'), function (d) {
      if (d.contains(e.target)) return;
      d.removeAttribute('open');
      var summary = d.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  });

  /* toggle ne remonte pas : écouté en capture */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches(LANG_SEL)) return;
    var summary = d.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', d.open ? 'true' : 'false');
  }, true);
})();
